import { projectConfigurationTypes } from '../const';

export const isLaminate = (type: string) => type === projectConfigurationTypes.LAMINATE;
